import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Expo Continents',
  basePath: '/expo-continents',
  columns: [
    { key: 'continent', label: 'Continent', sortable: true },
  ],
  fields: [
    { key: 'continent', label: 'Continent', type: 'text', required: true },
  ],
});
